module.exports = __webpack_public_path__ + "img/queda de folhas 3.52515a4e.webp";